import { render } from "./ContactBox.vue?vue&type=template&id=72b8f718&bindings={\"d\":\"data\",\"partOne\":\"data\",\"partTwo\":\"data\",\"partThree\":\"data\",\"telephone\":\"data\",\"telRef\":\"data\",\"gsmRef\":\"data\",\"gsm\":\"data\",\"complete\":\"options\",\"completeParam\":\"options\"}"
import script from "./ContactBox.vue?vue&type=script&lang=js"
export * from "./ContactBox.vue?vue&type=script&lang=js"
script.render = render

export default script